import React, { FC, useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack"
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { storage } from '../../firebaseData';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, FormControl, InputLabel, Typography } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import StoryDialog from '../storyDialog';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment, { Moment } from 'moment';
import { translations } from '../../translations';

interface familyMember {
  id: string,
  name: string,
  img: string,
  note: string,
  pid: string,
  tags: string[],
  role: string,
  created: Date,
  updated: Date
}

interface formData {
  name: string,
  img: string,
  familyBranch?: string,
}

interface props {
  openEditForm: boolean,
  hanleOpenEditForm: () => void,
  handleCloseEditForm: () => void,
  formStatus: string,
  handleAddNewMember: (data: any) => void,
  handleEditNewMember: (data: any) => void,
  handleSetEditorContent: (content:any) => void,
  memberSelected: any;
  nodes: familyMember[],
  editorContent: any,
  language: string
}

const FamilyForm: FC<props> = ({ language, openEditForm, editorContent, handleSetEditorContent, formStatus, nodes, memberSelected, handleEditNewMember, handleAddNewMember, hanleOpenEditForm, handleCloseEditForm }) => {
  const [formData, setFormData] = useState<any>({
    name: '',
    img: '',
    role: 'sameGrade',
    gender:'male',
    position: '',
    story:'',
    note: '',
    birthday:'',
    deadthday: '',
    familyBranch: ''
  });
  const [uploading, setUploading] = useState(false);
  const ENABLE_UPLOAD = false; // Đổi thành true khi Firebase có dung lượng
  const [birthday, setBirthday] = useState<Moment | null> (null)
  const [deadthday, setDeadthday] = useState<Moment | null> (null)
  const [fullEditorScreen , setFullEditorScreen] = useState(false)
  const fileInputRef = useRef<any>(null);
  const reactQuillRef = useRef<any>();

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileSelect = (e: any) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      if (file && file.size > 5 * 1024 * 1024) {
        alert('The image file size exceeds the 5MB limit.');
      } else {
        const storageRef = ref(storage, `member/${Date.now()}_${file.name}`);
        setUploading(true);
        uploadBytes(storageRef, file).then(() => {
          return getDownloadURL(storageRef);
        })
          .then((url) => {
            formData.img = url;
            setFormData({ ...formData })
          })
          .catch((error) => {
            console.error('Error uploading image:', error);
            alert('Upload failed: ' + (error.message || 'Unknown error. Check Firebase Rules.'));
          })
          .finally(() => {
            setUploading(false); // Set the uploading state back to false
          });
      }
    } else {
      console.log('No image selected.');
    }
  };

  const handleDeleteImage = () => {
    formData.img = ''
    setFormData({ ...formData })
  }

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeEditor = (value: string) => {
    // error library auto setState not yet change content after statusForm is edit
    handleSetEditorContent(value)
  };


  const handleDateChange = (name:string, date: Moment | null) => {
    if(date){
      const utcDate = moment(date).toDate();
      if(name === 'birthday'){
        formData.birthday = utcDate
        setBirthday(date)
      }else{
        formData.deadthday = utcDate
        setDeadthday(date)
      }
      setFormData({...formData});
    }
  };

  useEffect(() => {
    if (formStatus === 'add') {
      let dataReset = {
        name: '',
        img: '',
        role: 'sameGrade',
        gender: 'male',
        position: '',
        story:'',
        note: '',
        birthday:'',
        deadthday: '',
        familyBranch: ''
      }
      setFormData({ ...dataReset })
      setBirthday(null)
      setDeadthday(null)
      handleSetEditorContent('')
    } else if (formStatus === 'edit') {
      if (memberSelected) {
        handleSetEditorContent(memberSelected.story)
        if(memberSelected.birthday){
          if(memberSelected.birthday.seconds){
            let momentObject = moment.unix(memberSelected.birthday.seconds);
            setBirthday(momentObject)
          }else{
            let momentObject = moment(memberSelected.birthday);
            setBirthday(momentObject)
          }
        }
        if(memberSelected.deadthday){
          if(memberSelected.deadthday.seconds){
            let momentObject = moment.unix(memberSelected.deadthday.seconds);
            setDeadthday(momentObject)
          }else{
            let momentObject = moment(memberSelected.deadthday);
            setBirthday(momentObject)
          }
        }
        setFormData({ ...memberSelected })
      } else {
        setFormData(null)
      }
    } else {
      setFormData({ ...memberSelected })
    }
  }, [memberSelected, formStatus])

  const handleToggleFullScreen =()=>{
       setFullEditorScreen(!fullEditorScreen)
  }

 
// console.log('formData', formData)
const toolbarOptions = [
  [{ 'size': ['small', false, 'large', 'huge'] }],
  ['bold', 'italic', 'underline','strike', 'blockquote'],
  [{ 'color': [] }, { 'background': [] }], 
  [{ 'align': [] }],
  [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
  ['link', 'image'],
  ['clean'],
];

  const earthyInputStyle = {
    borderRadius: '12px',
    backgroundColor: '#f5f2eb',
    '& .MuiOutlinedInput-notchedOutline': { border: '1px solid rgba(139, 115, 85, 0.2)' },
    '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid rgba(139, 115, 85, 0.4)' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: '2px solid #6b8e51' },
    '& .MuiInputBase-input': { fontWeight: 500, color: '#4a3f35' },
    transition: 'all 0.2s ease'
  };

  return (
    <div>
      <SwipeableDrawer
        anchor="right"
        open={openEditForm}
        onOpen={hanleOpenEditForm}
        onClose={handleCloseEditForm}
        PaperProps={{
          component: Paper,
          sx: {
            width: { xs: '100%', sm: '460px' },
            background: '#fdfbf7', // Warm cream background
            borderTopLeftRadius: { xs: 0, sm: '24px' },
            borderBottomLeftRadius: { xs: 0, sm: '24px' },
            boxShadow: '-10px 0 40px rgba(74, 59, 50, 0.08)' // Warm shadow
          }
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          {/* Header */}
          <Box sx={{ 
            flexShrink: 0,
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            px: 3, 
            py: 3, 
            background: 'rgba(253, 251, 247, 0.9)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            borderBottom: '1px solid rgba(139, 115, 85, 0.15)'
          }}>
            <Typography variant="h6" sx={{ fontFamily: 'Inter', fontWeight: 700, color: '#4a3f35', letterSpacing: '-0.5px' }}>
              {formStatus === 'add' ? translations[language as keyof typeof translations].addMember : translations[language as keyof typeof translations].editMember}
            </Typography>
            <IconButton onClick={handleCloseEditForm} size="small" sx={{ background: '#f5f2eb', '&:hover': { background: '#ebe6db' } }}>
              <CloseIcon sx={{ color: '#4a3f35', fontSize: 20 }} />
            </IconButton>
          </Box>

          {uploading ? (
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ flexGrow: 1 }}> 
              <CircularProgress sx={{ color: '#6b8e51' }} /> 
            </Stack>
          ) : (
            <>
              {/* Scrollable Form Content */}
              <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                <Stack spacing={4} sx={{ p: 3, pt: 2 }}>
                  
                  {/* Avatar Section */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileSelect}
                      accept="image/*"
                      style={{ display: 'none' }}
                    />
                    <Box sx={{ position: 'relative', '&:hover .avatar-overlay': { opacity: ENABLE_UPLOAD ? 1 : 0 } }}>
                      <Avatar
                        alt="Avatar"
                        src={formData.img || "https://t3.ftcdn.net/jpg/05/53/79/60/360_F_553796090_XHrE6R9jwmBJUMo9HKl41hyHJ5gqt9oz.jpg"}
                        sx={{ width: 120, height: 120, border: '3px solid #fdfbf7', boxShadow: '0 8px 24px rgba(139, 115, 85, 0.2)' }}
                      />
                      {ENABLE_UPLOAD && (
                        <Box 
                          className="avatar-overlay"
                          sx={{
                            position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                            borderRadius: '50%', backgroundColor: 'rgba(74, 63, 53, 0.6)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            opacity: 0, transition: 'opacity 0.2s', cursor: 'pointer'
                          }}
                          onClick={handleButtonClick}
                        >
                          <CloudUploadIcon sx={{ color: '#fff', fontSize: 32 }} />
                        </Box>
                      )}
                    </Box>
                    {ENABLE_UPLOAD && (
                      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                        <Button size="small" onClick={handleButtonClick} sx={{ textTransform: 'none', fontWeight: 600, color: '#6b8e51', background: 'rgba(107, 142, 81, 0.1)', borderRadius: '20px', px: 2, '&:hover': { background: 'rgba(107, 142, 81, 0.2)' } }}>
                          {language === 'vi' ? 'Tải ảnh lên' : 'Upload photo'}
                        </Button>
                        {formData.img && (
                          <Button size="small" onClick={handleDeleteImage} sx={{ textTransform: 'none', fontWeight: 600, color: '#c96a52', background: 'rgba(201, 106, 82, 0.1)', borderRadius: '20px', px: 2, '&:hover': { background: 'rgba(201, 106, 82, 0.2)' } }}>
                            {translations[language as keyof typeof translations].remove}
                          </Button>
                        )}
                      </Stack>
                    )}
                  </Box>

                  {/* Personal Info */}
                  <Box>
                    <Typography variant="caption" sx={{ color: '#8b7355', fontWeight: 700, letterSpacing: '0.5px', ml: 1, mb: 1.5, display: 'block', textTransform: 'uppercase' }}>
                      {language === 'vi' ? 'Thông tin cơ bản' : 'Basic Info'}
                    </Typography>
                    <Stack spacing={2}>
                      <TextField
                        label={translations[language as keyof typeof translations].name}
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        fullWidth
                        InputProps={{ sx: earthyInputStyle }}
                        InputLabelProps={{ sx: { color: '#8b7355', fontWeight: 500 } }}
                      />
                      
                      <TextField
                        label={language === 'vi' ? 'Nhánh gia đình (Tùy chọn)' : 'Family Branch (Optional)'}
                        name="familyBranch"
                        value={formData.familyBranch || ''}
                        onChange={handleChange}
                        fullWidth
                        placeholder={language === 'vi' ? 'Ví dụ: Chi 1, Nhánh họ Nguyễn...' : 'E.g., Branch 1...'}
                        InputProps={{ sx: earthyInputStyle }}
                        InputLabelProps={{ sx: { color: '#8b7355', fontWeight: 500 } }}
                      />
                      
                      <Stack direction="row" spacing={2}>
                        <FormControl fullWidth>
                          <InputLabel sx={{ color: '#8b7355', fontWeight: 500 }}>{translations[language as keyof typeof translations].gender}</InputLabel>
                          <Select
                            name="gender"
                            label={translations[language as keyof typeof translations].gender}
                            value={formData.gender}
                            onChange={handleChange}
                            sx={earthyInputStyle}
                          >
                            <MenuItem value="male">{translations[language as keyof typeof translations].male}</MenuItem>
                            <MenuItem value="female">{translations[language as keyof typeof translations].female}</MenuItem>
                          </Select>
                        </FormControl>

                        <TextField
                          label={translations[language as keyof typeof translations].position}
                          name="position"
                          value={formData.position}
                          onChange={handleChange}
                          fullWidth
                          InputProps={{ sx: earthyInputStyle }}
                          InputLabelProps={{ sx: { color: '#8b7355', fontWeight: 500 } }}
                        />
                      </Stack>

                      {formStatus === 'add' && (
                        <FormControl fullWidth>
                          <InputLabel sx={{ color: '#8b7355', fontWeight: 500 }}>{translations[language as keyof typeof translations].role}</InputLabel>
                          <Select
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                            label={translations[language as keyof typeof translations].role}
                            sx={earthyInputStyle}
                          >
                            <MenuItem value="sameGrade">{translations[language as keyof typeof translations].sameGrade}</MenuItem>
                            <MenuItem value="spouse">{translations[language as keyof typeof translations].spouse}</MenuItem>
                            <MenuItem value="lowerGrade">{translations[language as keyof typeof translations].lowerGrade}</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                      
                      <TextField
                        label={translations[language as keyof typeof translations].imageUrl}
                        name="img"
                        value={formData.img}
                        onChange={handleChange}
                        fullWidth
                        placeholder="https://"
                        InputProps={{ sx: earthyInputStyle }}
                        InputLabelProps={{ sx: { color: '#8b7355', fontWeight: 500 } }}
                      />
                    </Stack>
                  </Box>

                  {/* Dates */}
                  <Box>
                    <Typography variant="caption" sx={{ color: '#8b7355', fontWeight: 700, letterSpacing: '0.5px', ml: 1, mb: 1.5, display: 'block', textTransform: 'uppercase' }}>
                      {language === 'vi' ? 'Sự kiện' : 'Events'}
                    </Typography>
                    <Stack direction="row" spacing={2}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker 
                          label={translations[language as keyof typeof translations].birthday}
                          format='DD/MM/YYYY' 
                          value={birthday} 
                          onChange={(date) => handleDateChange('birthday', date)} 
                          slotProps={{
                            textField: { fullWidth: true, InputProps: { sx: earthyInputStyle }, InputLabelProps: { sx: { color: '#8b7355', fontWeight: 500 } } },
                            field: { clearable: true, onClear: () => {
                              setBirthday(null);
                              formData.formatBirthday = '';
                              formData.birthday = null;
                              setFormData({...formData});
                            }}
                          }}
                        />
                      </LocalizationProvider>
                      
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker 
                          label={translations[language as keyof typeof translations].deadthday}
                          format='DD/MM/YYYY' 
                          value={deadthday} 
                          onChange={(date) => handleDateChange('deadthday', date)} 
                          slotProps={{
                            textField: { fullWidth: true, InputProps: { sx: earthyInputStyle }, InputLabelProps: { sx: { color: '#8b7355', fontWeight: 500 } } },
                            field: { clearable: true, onClear: () => {
                              setDeadthday(null);
                              formData.formatDeadthday = '';
                              formData.deadthday = null;
                              setFormData({...formData});
                            }}
                          }}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Box>

                  {/* Story & Note */}
                  <Box>
                    <Typography variant="caption" sx={{ color: '#8b7355', fontWeight: 700, letterSpacing: '0.5px', ml: 1, mb: 1.5, display: 'block', textTransform: 'uppercase' }}>
                      {language === 'vi' ? 'Tiểu sử & Ghi chú' : 'Biography & Notes'}
                    </Typography>
                    <Stack spacing={2}>
                      <Box sx={{ height: '300px', display: 'flex', flexDirection: 'column', background: '#f5f2eb', borderRadius: '12px', border: '1px solid rgba(139, 115, 85, 0.2)', overflow: 'hidden' }}>
                        <Box sx={{ 
                          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                          px: 2, py: 1, borderBottom: '1px solid rgba(139, 115, 85, 0.1)'
                        }}>
                          <Typography sx={{ color: '#8b7355', fontSize: '14px', fontWeight: 600 }}>
                            {translations[language as keyof typeof translations].story}
                          </Typography>
                          <IconButton size="small" onClick={() => setFullEditorScreen(true)} sx={{ color: '#6b8e51' }}>
                            <FullscreenIcon fontSize="small" />
                          </IconButton>
                        </Box>
                        <Box sx={{ flexGrow: 1, '& .quill': { height: '100%', display: 'flex', flexDirection: 'column' }, '& .ql-container': { flexGrow: 1, border: 'none', fontFamily: 'Inter', color: '#4a3f35' }, '& .ql-toolbar': { border: 'none', borderBottom: '1px solid rgba(139, 115, 85, 0.1)' } }}>
                          <ReactQuill 
                            ref={reactQuillRef} 
                            value={editorContent}
                            onChange={handleChangeEditor}
                            modules={{ toolbar: toolbarOptions }}
                          />
                        </Box>
                      </Box>

                      <TextField
                        label={translations[language as keyof typeof translations].note}
                        multiline
                        rows={3}
                        name="note"
                        value={formData.note}
                        onChange={handleChange}
                        fullWidth
                        InputProps={{ sx: earthyInputStyle }}
                        InputLabelProps={{ sx: { color: '#8b7355', fontWeight: 500 } }}
                      />
                    </Stack>
                  </Box>
                </Stack>
              </Box>

              {/* Footer */}
              <Box sx={{ 
                flexShrink: 0,
                background: 'rgba(253, 251, 247, 0.95)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                borderTop: '1px solid rgba(139, 115, 85, 0.15)',
                p: 2.5,
                px: 3,
                display: 'flex',
                gap: 2
              }}>
                <Button 
                  variant="outlined" 
                  fullWidth
                  onClick={handleCloseEditForm}
                  sx={{ 
                    borderRadius: '12px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.95rem',
                    color: '#8b7355',
                    borderColor: 'rgba(139, 115, 85, 0.3)',
                    py: 1,
                    '&:hover': { background: 'rgba(139, 115, 85, 0.08)', borderColor: 'rgba(139, 115, 85, 0.5)' }
                  }}
                >
                  {translations[language as keyof typeof translations].close}
                </Button>
                <Button 
                  variant="contained" 
                  fullWidth
                  onClick={() => formStatus === 'add' ? handleAddNewMember(formData) : handleEditNewMember(formData)}
                  sx={{ 
                    borderRadius: '12px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.95rem',
                    backgroundColor: '#6b8e51',
                    color: '#fff',
                    boxShadow: '0 4px 12px rgba(107, 142, 81, 0.25)',
                    py: 1,
                    '&:hover': { 
                      backgroundColor: '#5a7d46',
                      boxShadow: '0 6px 16px rgba(107, 142, 81, 0.35)',
                      transform: 'translateY(-1px)'
                    },
                    transition: 'all 0.2s ease'
                  }}
                >
                  {translations[language as keyof typeof translations].saveAndClose}
                </Button>
              </Box>
            </>
          )}
        </Box>

        {fullEditorScreen && (
          <StoryDialog 
            open={fullEditorScreen} 
            storyContent={editorContent} 
            handleChangeContent={handleSetEditorContent} 
            handleToggleFullScreen={handleToggleFullScreen} 
          />
        )}
      </SwipeableDrawer>
    </div>
  );
};

export default FamilyForm;